import React from 'react';
import styled from "styled-components";
import {colors} from "../../maps/colors";
import ShowPrice from "../ShowPrice";
import {hasRTLCharacters} from "../../utils";

const WrapperStyled = styled.div`
  background-color: rgb(255, 255, 255);
  color: rgb(33, 43, 54);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  overflow: hidden;
  box-shadow: rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px;
  border-radius: 12px;
  position: relative;
  height: 180px;

  img {
    height: 100px;
    width: 100%;
    object-fit: cover;
  }

  h3 {
    font-size: 14px;
    padding: 0 6px 13px;
    margin: 0;
    direction: ltr;
    text-align: left;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &.rtl {
      direction: rtl;
      text-align: right;
    }
  }
`;

const InfoStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 7px;

  .product-info-label {
    color: ${colors.LIGHT_GRAY};
    font-size: 11px;
    margin-right: 3px;
  }
`;

const InfoCountStyled = styled.div`
  text-align: left;
`;

const InfoPriceStyled = styled.div`
  text-align: right;
`;

const ProductInCart = ({product}) => {
    return (
        <WrapperStyled>
            <img style={{height: 200}} src={product.imageUrl} alt={product.name}/>
            <h3 className={hasRTLCharacters(product.name) ? "rtl" : "ltr"}>{product.name}</h3>
            <InfoStyled>
                <InfoCountStyled>
                    <span className="product-info-label">
                        Quantity
                    </span>
                    {product.quantity || 1}
                </InfoCountStyled>
                <InfoPriceStyled>
                    <span className="product-info-label">
                        Price
                    </span>
                    <ShowPrice price={product.price}/>
                </InfoPriceStyled>
            </InfoStyled>
        </WrapperStyled>
    );
};

export default ProductInCart;